/**
 * Media URL helpers — shared by training content editor and the
 * trainee-facing module viewer.
 *
 * Keeps URL shape handling in one place so YouTube Shorts, youtu.be
 * short links, and classic watch?v= URLs all render as iframe embeds
 * the same way.
 */

const YOUTUBE_ID_RE = /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/;

export function toEmbedUrl(url: string): string {
  const match = url.match(YOUTUBE_ID_RE);
  if (match) return `https://www.youtube.com/embed/${match[1]}`;
  return url;
}

export function isImageUrl(url: string): boolean {
  return /\.(png|jpe?g|gif|webp|svg|avif)(\?|$)/i.test(url);
}

export function isYouTubeUrl(url: string): boolean {
  return /(?:youtube\.com|youtu\.be)/.test(url);
}

export function youTubeThumbnail(url: string): string | null {
  const m = url.match(YOUTUBE_ID_RE);
  if (!m) return null;
  return `https://img.youtube.com/vi/${m[1]}/mqdefault.jpg`;
}
